import React from 'react';
import { useLocation } from 'react-router-dom';
import { useStorageState } from 'react-storage-hooks';
import { SSO_POST_LOGOUT_REDIRECT_PATH, SSO_REDIRECT_PATH } from '@/utils/constants';

const DataLayerLoginLogoutListener = () => {
  const [, setIsLoggedIn] = useStorageState(sessionStorage, 'DATALAYER.IS_LOGGED_IN', false);
  const [, setIsLoggedOut] = useStorageState(sessionStorage, 'DATALAYER.IS_LOGGED_OUT', false);
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname.startsWith(SSO_REDIRECT_PATH)) setIsLoggedIn(true);

    if (location.pathname.startsWith(SSO_POST_LOGOUT_REDIRECT_PATH)) setIsLoggedOut(true);
  }, [location.pathname, setIsLoggedIn, setIsLoggedOut]);

  return null;
};

export default React.memo(DataLayerLoginLogoutListener);
